module.exports = __webpack_public_path__ + "static/media/Rotessa-Sidebar-Icon-Notifications-Update.21fab21d.png";